import { getCSSVar } from "utils/styling";

import type { CrremPathwayOverlayLine } from "../model/types";

import { scaleChartValue } from "./scaleChartValues";

type ModernizationSeriesRow = {
  baseline?: number;
  crrem?: number;
  current?: number;
  modernized?: number;
  retrofit?: number;
  year?: number;
};

const pointsFor = (
  data: ModernizationSeriesRow[],
  key: "modernized" | "retrofit",
  areaDivisor?: number,
  grossArea?: number
) =>
  data
    .filter((row) => typeof row.year === "number" && typeof row[key] === "number")
    .map((row) => ({
      value: scaleChartValue(row[key] as number, areaDivisor, grossArea),
      year: row.year as number,
    }));

export const buildModernizationOverlayLines = (
  data: ModernizationSeriesRow[],
  areaDivisor?: number,
  grossArea?: number
): CrremPathwayOverlayLine[] => {
  const lines: CrremPathwayOverlayLine[] = [];
  const modernized = pointsFor(data, "modernized", areaDivisor, grossArea);
  const retrofit = pointsFor(data, "retrofit", areaDivisor, grossArea);
  if (modernized.length) {
    lines.push({
      color: getCSSVar("--color-purpose-modernization-charts-modernized"),
      id: "modernized",
      keepYearDuplicates: true,
      lineType: "solid",
      name: "Modernized",
      points: modernized,
      symbol: "none",
    });
  }
  if (retrofit.length) {
    lines.push({
      color: getCSSVar("--color-purpose-modernization-charts-retrofit"),
      connectNulls: false,
      id: "retrofit",
      keepYearDuplicates: true,
      lineType: "dashed",
      name: "Retrofit",
      points: retrofit,
      symbol: "circle",
    });
  }
  return lines;
};
